module.exports = __webpack_public_path__ + "img/amazon_feedback_removal.png";